import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { BookOpen, Lightbulb, Rocket, GraduationCap, Briefcase, Check, ChevronDown } from 'lucide-react';

const services = [
  {
    id: 'class-2-7',
    label: 'CLASS 2–7',
    icon: <BookOpen size={32} />,
    title: 'Career Analysis for 2nd to 7th Class',
    desc: 'It will help you to find out Multiple Intelligence of the Student',
    bestFor: 'Parents wanting early academic and extracurricular direction for their child.',
    includes: ['Age-appropriate psychometric assessment', 'Multiple Intelligence profiling', 'Parent-counsellor debrief session', 'Illustrated, easy-to-understand report'],
    altBg: false,
  },
  {
    id: 'class-8-10',
    label: 'CLASS 8–10',
    icon: <Lightbulb size={32} />,
    title: 'Career Analysis for 8th, 9th & 10th Class',
    desc: 'It will help you to find out most suitable career path and subjects',
    bestFor: 'Students entering or currently in secondary school who are unsure about their stream selection.',
    includes: ['Full psychometric battery (Aptitude & Interest)', '1-hour deep-dive counselling session', 'Stream recommendation & subject mapping', 'Extracurricular activity planning'],
    altBg: true,
  },
  {
    id: 'class-11-12',
    label: 'CLASS 11–12',
    icon: <Rocket size={32} />,
    title: 'Career Analysis for 11th & 12th Class',
    desc: 'It will help you to find out most suitable career path and career road map with detailed execution plan',
    bestFor: 'Students planning college admissions and competitive exams.',
    includes: ['Comprehensive 20+ page career report', 'College and entrance exam roadmap', 'Top 3 career cluster recommendations', 'Detailed execution plan', 'Follow-up session for ongoing support'],
    altBg: false,
  },
  {
    id: 'graduates',
    label: 'GRADUATES',
    icon: <GraduationCap size={32} />,
    title: 'Career Analysis for Graduates',
    desc: 'It will help you to find out Most Suitable Career path and Career Road map with detailed execution plan',
    bestFor: 'Fresh graduates or final-year students feeling uncertain about their next step.',
    includes: ['In-depth personality & skills assessment', 'Personalised job-market roadmap', 'Higher education vs. Employment analysis', 'Detailed execution plan', 'Strengths profiling for interviews'],
    altBg: true,
  },
  {
    id: 'professionals',
    label: 'PROFESSIONALS',
    icon: <Briefcase size={32} />,
    title: 'Career Analysis for Professionals',
    desc: 'Early and Mid career counselling for professionals with detailed execution plan',
    bestFor: 'Working professionals at a crossroads, seeking a career pivot or advancement.',
    includes: ['Extended professional psychometric battery', 'Executive counselling & strategy session', 'Skills gap analysis for career pivots', 'Strategic action plan for the next 10 years'],
    altBg: false,
  },
];

const Services = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
  >
    <section className="Services_hero__Pf3HD">
      <div className="container Services_heroContainer__YsxQ0">
        <motion.span
          className="section-label"
          style={{ color: 'var(--c-gold)' }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          CAREER GUIDANCE
        </motion.span>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          Psychometric Career Assessment
        </motion.h1>
        <motion.p
          className="Services_heroSubtext__v9SFD"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          Science-backed guidance tailored for every stage of your educational and professional journey.
        </motion.p>
      </div>
    </section>

    {services.map((service) => (
      <section key={service.id} className={`section ${service.altBg ? 'section-alt' : ''}`} id={service.id}>
        <div className="container Services_serviceLayout__An0bb">
          <div className="Services_serviceContent__NsCGh">
            <div className="Services_serviceLabelRow__-EMGq">
              <div className="Services_serviceIconWrap__r6I6C">{service.icon}</div>
              <span className="section-label">{service.label}</span>
            </div>
            <h2>{service.title}</h2>
            <p className="Services_serviceDesc__kYzTd">{service.desc}</p>
            <div className="Services_bestFor__ve6q7">
              <strong>Best for:</strong> {service.bestFor}
            </div>
            <div className="Services_priceCta__AXbir">
              <a
                href="https://vitaecareer.edumilestones.com"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary"
              >
                Book Now →
              </a>
            </div>
          </div>
          <div className="Services_serviceCardWrap">
            <div className="Services_inclusionCard__2g0AT">
              <h3>What's Included</h3>
              <ul className="Services_inclusionList__t0fzm">
                {service.includes.map((item, index) => (
                  <li key={index}>
                    <Check size={20} className="Services_checkIcon__slsJO" />
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>
    ))}

    <section className="Services_partnershipSection__amYDl">
      <div className="container Services_partnershipContainer__lpb2U">
        <h2>School & College Group Assessments</h2>
        <p>
          Special discounts are available for group counselling sessions conducted in schools and colleges. We partner with educational institutions across Lucknow and Balrampur to bring career clarity to students at scale — offering on-site assessment camps, bulk pricing discounts, and dedicated institutional reports. Terms and conditions apply.
        </p>
        <Link to="/contact" className="btn-primary" style={{ marginTop: '24px' }}>
          Contact Us About Group Assessments →
        </Link>
      </div>
    </section>
  </motion.div>
);

export default Services;